import {
  POST_LETTER_ORDERS_ORDER_REQUEST,
  POST_LETTER_ORDERS_ORDER_SUCCESS,
  POST_LETTER_ORDERS_ORDER_FAILURE,
  POST_USERS_ME_PLANS_SUCCESS,
  POST_USERS_PAYMENTS_AND_PLANS_SUCCESS,
  POST_SENDER_REQUEST,
  POST_SENDER_SUCCESS,
  POST_SENDER_FAILURE,
  POST_ORDER_CONTACTS_REQUEST,
  POST_ORDER_CONTACTS_SUCCESS,
  POST_ORDER_CONTACTS_FAILURE,
  SET_SHOW_SEND_ORDER_INFO_BOX,
} from '../../constants/ActionTypes'
import * as errMessages from '../../constants/ErrorMessages';
import * as messages from '../../constants/Messages'
import { formatErrorMessage } from "../../utils/utils";

const initialState = {
  isPosting: false,
  shortMessage: '',
  successMessage: '',
  errorMessage: '',
  sender: {},
  orderContact: {},
  isSaving: false,
  isSavingOrderContact: false,
  showSendLetterInfoBox: true,
};

export default (state = initialState, action) => {
  state = {
    ...state,
    shortMessage: '',
    successMessage: '',
    errorMessage: '',
    error: null,
  }

  switch (action.type) {
    case POST_LETTER_ORDERS_ORDER_REQUEST:
      return {
        ...state,
        isPosting: true,
      }
    case POST_LETTER_ORDERS_ORDER_SUCCESS:
      return {
        ...state,
        isPosting: false,
      }
    case POST_LETTER_ORDERS_ORDER_FAILURE: {
      const errorResponse = action.payload.error;

      // タイムアウトや通信断ではAPIのエラーメッセージを組み立てられないため、
      // action側で決めたメッセージをそのまま使う。
      // ApiClientがresponseを補完するのでerrorResponseは存在する。errorの有無では判定できない。
      if (action.payload.message) {
        return {
          ...state,
          isPosting: false,
          errorMessage: action.payload.message,
        }
      }

      // ここで無条件にerrorResponseを参照すると例外が投げられてstateが更新されず、
      // isPostingがtrueのまま固定されて注文ボタンがローディングのまま止まってしまう。
      if (!errorResponse) {
        return {
          ...state,
          isPosting: false,
          errorMessage: errMessages.ERR_ORDER_FAILURE,
        }
      }

      let err = errorResponse.data && errorResponse.data.message;
      let message = '';

      if (typeof err === 'string') {
        message = err;
      } else if (err && typeof err === 'object') {
        // typeof null === 'object' のため、nullを除外しないとObject.valuesで例外になる
        Object.values(err).forEach((item) => {
          if (Array.isArray(item)) {
            message += item.join(' ')
          }
        });
      }

      return {
        ...state,
        isPosting: false,
        errorMessage: message ? [errMessages.ERR_ORDER_FAILURE, message] : errMessages.ERR_ORDER_FAILURE,
      }
    }
    case POST_USERS_PAYMENTS_AND_PLANS_SUCCESS:
    case POST_USERS_ME_PLANS_SUCCESS:
      return {
        ...state,
        isSavingPlan: false,
        shortMessage: messages.CHANGE_SUCCESS,
      }
    case POST_ORDER_CONTACTS_REQUEST:
      return {
        ...state,
        isSavingOrderContact: true,
      };
    case POST_ORDER_CONTACTS_SUCCESS:
      return {
        ...state,
        orderContact: action.payload.orderContact,
        isSavingOrderContact: false,
        shortMessage: messages.SAVE_SUCCESS,
      };
    case POST_ORDER_CONTACTS_FAILURE:
      return {
        ...state,
        errorMessage: formatErrorMessage(
          action.payload.error,
          errMessages.ERR_SAVE_FAILURE
        ),
        orderContact: initialState.orderContact,
        isSavingOrderContact: false,
      };
    case POST_SENDER_REQUEST:
      return {
        ...state,
        isSaving: true,
      };
    case POST_SENDER_SUCCESS:
      return {
        ...state,
        sender: action.payload.sender,
        isSaving: false,
        shortMessage: messages.SAVE_SUCCESS,
      };
    case POST_SENDER_FAILURE:
      return {
        ...state,
        isSaving: false,
        errorMessage: formatErrorMessage(
          action.payload.error,
          errMessages.ERR_SAVE_FAILURE
        ),
      };
    case SET_SHOW_SEND_ORDER_INFO_BOX:
      return {
        ...state,
        showSendLetterInfoBox: action.payload.showSendLetterInfoBox,
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/sendLetter.js